import PhoneInput2 from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface PhoneInputProps {
  value?: string;
  onChange: (formattedValue: string) => void;
  placeholder?: string;
  className?: string;
}

export const PhoneInputComponent = ({
  value,
  onChange,
  placeholder,
  className,
}: PhoneInputProps) => {
  return (
    <PhoneInput2
      country="us"
      value={value}
      onChange={(_, __, ___, formattedValue) => {
        onChange(formattedValue || "");
      }}
      placeholder={placeholder}
      inputClass={className}
      containerClass="phone-input-container"
      inputStyle={{
        width: "100%",
        height: "44px",
        fontSize: "14px",
        border: "1px solid #d1d5db",
        borderRadius: "8px",
        paddingLeft: "48px",
      }}
      buttonStyle={{
        border: "1px solid #d1d5db",
        borderRadius: "8px 0 0 8px",
        backgroundColor: "white",
      }}
      dropdownStyle={{
        borderRadius: "8px",
        boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
      }}
    />
  );
};
